<script setup>
import { defineProps, defineEmits, watch, ref, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";
import UtilDateTime from "@/utils/UtilDateTime";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "revisandoDado",
    "ncms",
    "controlesDesativados",
]);

const emits = defineEmits([
    "update:alteraDado",
]);

//==================================================================//
//============================ Refs ================================//
//==================================================================//

const refNCM = ref(null);

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraDado = (update) =>{

    emits('update:alteraDado',update);

};

//==================================================================//
//============== Regras Data Entrega Contratual ====================//
//==================================================================//
    
const regrasDataEntregaContratual = [
    dataEntregaContratual => {

        //==================================================================//
        //========= Se a Data for Undefined, ignore a validação ============//
        //==================================================================//

        if(dataEntregaContratual === undefined){
            return true;
        }

        //==================================================================//
        //==== Se a Data de Entrega Contratual for Menor ou Igual a Hoje ===//
        //==================================================================//

        let dataEntregaContratualMenorOuIgualAHoje = UtilDateTime.lessThanOrEqualToToday({
            dateTime: dataEntregaContratual,
        });

        if(dataEntregaContratualMenorOuIgualAHoje){
            return 'Data Entrega Contratual é menor que a data de hoje.';
        }

        return true;
       
    }

];

//==================================================================//
//======================= Regras NCM ===============================//
//==================================================================//
    
const regrasNCM = [
    ncm => {
        if(ncm?.id){
            return true;
        }
        return 'NCM é obrigatório.';
       
    }
];

//==================================================================//
//========== Ao Selecionar Data de Entrega Contratual ==============//
//==================================================================//

const aoSelecionarDataEntregaContratual = (dataEntregaContratual) =>{

    //==================================================================//
    //======== Se a Data de Entrega Contratual for Invalida ============//
    //==================================================================//

    let dataEntregaContratualInvalida = UtilDateTime.isInvalid({dateTime:dataEntregaContratual});

    if(dataEntregaContratualInvalida){

        alteraDado({
            dataEntregaContratual: "",
            dataEntregaContratualFormatada: "",
        });

        return;

    }

    //==================================================================//
    //==== Se a Data de Entrega Contratual for Menor ou Igual a Hoje ===//
    //==================================================================//

    let dataEntregaContratualMenorOuIgualAHoje = UtilDateTime.lessThanOrEqualToToday({
        dateTime: dataEntregaContratual,
    });

    if(dataEntregaContratualMenorOuIgualAHoje){

        alteraDado({
            dataEntregaContratual: "",
            dataEntregaContratualFormatada: "",
        });

        return;

    }

    //==================================================================//
    //============= Preencha a Data de Entrega Contratual ==============//
    //================ Preencha a Data de Encerramento =================//
    //==================================================================//

    let dataEntregaContratualUTC = UtilDateTime.toFormatUTC({dateTime:dataEntregaContratual});
    let dataEntregaContratualBrazil = UtilDateTime.toFormatBrazil({dateTime:dataEntregaContratual});

    alteraDado({
        dataEntregaContratual: dataEntregaContratualUTC,
        dataEntregaContratualFormatada: dataEntregaContratualBrazil,
    });

};

//==================================================================//
//============ Ao Selecionar Coordenador de Contratos ==============//
//==================================================================//

const aoSelecionarNCM = (ncm) =>{

    alteraDado({
        ncm: ncm || {}
    });

};

//==================================================================//
//============= Data De Entrega Contratual Preenchida ==============//
//==================================================================//

const dataEntregaContratualPreenchida = computed(()=>{

    return props?.dado?.dataEntregaContratual ? true : false;

});

//==================================================================//
//================ Data De Entrega Maior que Hoje ==================//
//==================================================================//

const dataEntregaContratualMaiorQueHoje = computed(()=>{

    return UtilDateTime.greatherThanToday({
        dateTime: props?.dado?.dataEntregaContratual,
    });

});

//==================================================================//
//============= Desativa Data de Entrega Contratual ================//
//==================================================================//

const desativaDataEntregaContratual = computed(()=>{

    if(props?.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//========================= Desativa NCM ===========================//
//==================================================================//

const desativaNCM = computed(()=>{

    if(props?.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//=================== Watch => revisandoDado =======================//
//==================================================================//

watch(()=> props.revisandoDado, async () => {

    if(props.revisandoDado == false){

        refNCM.value.reset();

    }

});

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">

                Job {{ props?.dado?.codigo }}

            </h3>

            <div
                class="c-header__medidores"
            >

                <div class="c-medidor .c-medidor--valor-job">

                    <v-chip class="c-medidor__chip"
                        color="primary"
                        dark
                        label
                    >

                        {{ props?.dado?.status }}

                    </v-chip>

                </div>

                <div class="c-medidor .c-medidor--valor-na-previsao">

                    <v-chip class="c-medidor__chip"
                        color="green"
                        dark
                        label
                    >

                        Valor do Job:
                        {{UtilMoney.toR$BRL(props?.dado?.valorAtual)}}

                    </v-chip>

                </div>

            </div>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <div class="c-conjunto-de-campos">

                    <v-text-field class="c-campo__input"
                        label="Solicitacao de Orçamento"
                        :value="props?.dado?.solicitacaoDeOrcamento?.codigo"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Tipo de Equipamento"
                        :value="props?.dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.descricao"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-conjunto-de-campos">

                    <v-text-field class="c-campo__input"
                        label="Data de Abertura"
                        :value="props?.dado?.dataAberturaFormatada"
                        outlined
                        disabled
                        prepend-icon="mdi-calendar" 
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Data de Entrega Contrutual"
                        :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataEntregaContratual})"
                        :disabled="desativaDataEntregaContratual"
                        :rules="regrasDataEntregaContratual"
                        type="date"
                        prepend-icon="mdi-calendar" 
                        outlined
                        return-object
                        @input="aoSelecionarDataEntregaContratual"
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Data de Encerramento"
                        :value="UtilDateTime.toFormatISO({dateTime:props?.dado?.dataEncerramento})"
                        type="date"
                        disabled
                        prepend-icon="mdi-calendar" 
                        outlined
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-conjunto-de-campos">

                    <v-text-field class="c-campo__input"
                        label="Comercial"
                        :value="props?.dado?.comercial?.nome"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Gestor de Contrato"
                        :value="props?.dado?.gestorDeContratos?.nome"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                    <v-text-field class="c-campo__input"
                        label="Coordenador de Contratos"
                        :value="props?.dado?.coordenadorDeContratos?.nome"
                        outlined
                        disabled
                        return-object
                    ></v-text-field>

                </div>

                <div class="c-conjunto-de-campos">

                    <v-autocomplete class="c-busca__input"
                        ref="refNCM"
                        label="NCM"
                        :items="props?.ncms"
                        :value="props?.dado?.ncm"
                        :disabled="desativaNCM"
                        :rules="regrasNCM"
                        outlined
                        return-object
                        item-text="descricaoCompleta"
                        @input="aoSelecionarNCM"
                    ></v-autocomplete>

                </div>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: max-content 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo medidores";
}

.c-titulo {
    grid-area: titulo;
}

.c-header__medidores{
    grid-area: medidores;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: space-between;
}

.c-conjunto-de-campos{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
    grid-gap: 0px 20px;
}

@media (width <= 650px) {

    .c-cartao__titulo{
        display: grid; 
        grid-template-columns: 1fr; 
        grid-template-rows: 1fr 1fr; 
        grid-template-areas: 
            "titulo"
            "medidores";
    }

}

</style>